import React from "react"
import PropTypes from "prop-types"
import { Navigate, useLocation } from "react-router-dom"
import useAdminPermission from "../../hooks/useAdminPermission"

/**
 * Blocks admin routes when staff lacks required permission.
 * Waits for /me bootstrap before enforcing.
 */
const AdminPermissionGate = ({ children }) => {
  const location = useLocation()
  const { canRoute, isReady, isSuperAdmin, defaultAdminPath } = useAdminPermission()

  if (!isReady && !isSuperAdmin) {
    return (
      <div className="admin-layout__permission-loading" aria-busy="true" />
    )
  }

  if (canRoute(location.pathname)) {
    return children
  }

  return (
    <Navigate
      to={defaultAdminPath}
      replace
      state={{ from: location.pathname, reason: "forbidden" }}
    />
  )
}

AdminPermissionGate.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AdminPermissionGate
